'use strict';

/*global Container */
/*global Translator */
/*global K2Modal */
/*global Router*/
/*global Notifications*/
/*global Parameters*/

var services = new Container();
$(document).ready(function () {
  services.set('translator', new Translator('k2_translations'));
  services.set('modal', new K2Modal('k2-modal'));
  services.set('modal-lookup', new K2Modal('k2-modal-lookup'));
  services.set('router', new Router('k2_paths'));
  services.set('notifications', new Notifications());
  services.set('parameters', new Parameters());
});
